/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect } from "react";
import {
  PortModelAlignment,
  PortWidget,
} from "@projectstorm/react-diagrams-core";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../../Components/ErrorBoundary";
import "./style.scss";
import WorkflowSummary from "./SummaryView/WorkflowSummary";
import Context from "../../../store/context";
import CustomPortModel from "../../ports/CustomPort/CustomPortModel";
import checkIfDynamicContactUsed from "./helpers/checkIfDynamicContactUsed";
import {
  deleteWorkflow,
  selectEventHandlers,
  selectWorkflow,
  selectWorkflows,
} from "../../../store/slices/projectSlice";
import { selectSendLists } from "../../../store/slices/sendListsSlice";
import { faCog, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useConfirmDialog } from "../../Components/ConfirmDialogContext";

export default function LogicNodeWidget({ node }) {
  const confirmDialog = useConfirmDialog();
  const params = useParams();
  const { engine } = useContext(Context);
  const sendLists = useSelector(selectSendLists);

  const state = useSelector(selectWorkflow(node.options.id)) || {};
  const workflows = useSelector(selectWorkflows);
  const eventHandlers = useSelector(selectEventHandlers);
  const dispatch = useDispatch();

  useEffect(() => {
    const p = node.getPort("In");
    if (!state.IsEntrypoint && !p) {
      node.addPort(
        new CustomPortModel({
          in: true,
          name: "In",
          alignment: PortModelAlignment.LEFT,
        })
      );
    } else if (state.IsEntrypoint && p) {
      node.removePort(p);
    }

    // check all the actions for ports
    setTimeout(() => {
      (state.EventListeners || []).forEach((listener) => {
        const eventHandler = eventHandlers.find(
          (eh) => eh.UUID === listener.EventHandlerUUID
        ) || { Rules: [] };
        eventHandler.Rules?.forEach((rule) => {
          rule.Actions?.forEach((action) => {
            const portName = `${listener.UUID}|${action.UUID}`;
            if (action.Type === "start:runtime") {
              let newPort = node.getPort(portName);
              // Add a port if needed
              if (!newPort) {
                newPort = new CustomPortModel({
                  in: false,
                  name: portName,
                  alignment: PortModelAlignment.RIGHT,
                  isModule: eventHandler.IsModule,
                });
                node.addPort(newPort);
              }
              newPort.action = action;
              newPort.listener = listener;
              // check for connected nodes
              let link = Object.values(newPort.links)[0];
              const targetNode = engine.model.getNode(action.TypeUUID);
              if (action.TypeUUID) {
                if (!link) {
                  link = newPort.link(targetNode?.getPort("In"));
                  engine.model.addAll(link);
                  engine.repaintCanvas();
                }
                if (link) {
                  if (action.Type === "stop:runtime") {
                    link.setColor("red");
                  } else if (action.StartWith === "NewThread") {
                    link.setColor("green");
                  } else if (action.StartWith === "MainThread") {
                    link.setColor("blue");
                  } else if (action.StartWith === "CurrentThread") {
                    link.setColor("black");
                  }
                }
                // remove unnecessary links
              } else if (link) {
                link.remove();
                engine.repaintCanvas();
              }
            }
          });
        });
      });
    }, 100);
  }, [eventHandlers, workflows]);

  const inheritedFromPorts = [];

  workflows.forEach((workflow) =>
    workflow.EventListeners?.forEach((el) =>
      eventHandlers
        .find((eh) => eh.UUID === el.EventHandlerUUID)
        ?.Rules?.forEach((rule) =>
          rule.Actions?.forEach((action) => {
            if (action.TypeUUID === state.UUID && action.InheritContactSet) {
              inheritedFromPorts.push({
                workflowUUID: workflow.UUID,
                event: el.EventType,
                eventListenerUUID: el.UUID,
                actionUUID: action.UUID,
              });
            }
          })
        )
    )
  );

  const checkIfHasSendLIst = () => {
    const sendList = sendLists.find((sl) => sl.uuid === state.UUID);
    if (
      sendList &&
      (sendList.contacts?.length > 0 ||
        sendList.contactSets?.length > 0 ||
        sendList.filters?.length > 0)
    ) {
      return true;
    }
    return false;
  };

  return (
    <ErrorBoundary>
      <div
        tabIndex={-1}
        className={`custom-node p-3 rounded-3 bg-purple-gradient 
      ${node.options.selected ? " selected" : ""}
      `}
      >
        {/* show IN port for nodes other than triggers */}
        {node.getPort("In") && (
          <div className="in-ports">
            <div className="custom-node-port">
              <PortWidget
                engine={engine}
                port={node.getPort("In")}
                className="circle-porter circle-porter-in"
              >
                <div className="circle-port" />
              </PortWidget>
            </div>
          </div>
        )}

        {/* Heading */}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-end">
            {/* TITLE */}
            <h6 className="card-title">{state.Label} </h6>
            <div>
              {inheritedFromPorts.length > 0 ? (
                <Link
                  to={`/library/logic/builder/${params.projectID}/workflow/${state.UUID}/inherited-from`}
                  className="badge bg-colored badge-pill px-2 mx-2"
                >
                  Inherits DCS
                </Link>
              ) : (
                ""
              )}
              {checkIfDynamicContactUsed(state, eventHandlers) ? (
                <span className="badge bg-colored badge-pill px-2 mx-2">
                  Contact context created
                </span>
              ) : (
                ""
              )}
              {state.MessageTemplateUUID ? (
                <span className="badge bg-colored badge-pill px-2 mx-2">
                  Has message template
                </span>
              ) : (
                ""
              )}
              {checkIfHasSendLIst() ? (
                <Link
                  className="badge bg-colored badge-pill px-2 mx-2 text-white"
                  to={`/library/logic/builder/${params.projectID}/workflow/${state.UUID}/send-list`}
                >
                  Workflow contacts
                </Link>
              ) : (
                ""
              )}
              {state.IsEntrypoint ? (
                <span className="badge bg-colored badge-pill px-2 mx-2">
                  First workflow
                </span>
              ) : (
                ""
              )}
              {/* Delete button */}
              {!state.IsEntrypoint && (
                <button
                  type="button"
                  onClick={async () => {
                    const ans = await confirmDialog(
                      "Delete workflow",
                      `Are you sure you want to delete the workflow "${state.Label}"?`
                    );
                    if (ans) {
                      if (node.remove(true)) {
                        dispatch(deleteWorkflow(state.UUID));
                      }
                      engine.repaintCanvas();
                    }
                  }}
                  className="btn btn-outline-secondary border-0"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}

              {/* Show cog for configuration */}
              <Link
                className="btn btn-outline-secondary border-0"
                to={`/library/logic/builder/${params.projectID}/workflow/${state.UUID}/configuration`}
              >
                <FontAwesomeIcon icon={faCog} />
              </Link>
            </div>
          </div>
        </div>
        {/* Show node widget contents */}
        <div className="card-body">
          <WorkflowSummary state={state} node={node} engine={engine} />
        </div>
      </div>
    </ErrorBoundary>
  );
}
